module.exports = __webpack_public_path__ + "static/media/manageMaterials.a802485d.svg";